import {
  Box,
  Paper,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  MenuItem,
} from "@mui/material";

import { FilterCell, TableFilterInput } from "./filterCell";

const UsersTableSection = ({
  exportUsers,
  subscriptionLookupStatus,

  filters,
  handleSearchChange,

  uniqueProfessions,
  uniqueAgeGroups,

  columnWidths,

  paginated,
  formatDateTime, 
  filteredUsersLength,

  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  PAGE_SIZE_OPTIONS,
}) => {
  return (
    <Paper>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          mt: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontSize: 20 }}>
          Table of Users
        </Typography>

        <Button
          sx={{ 
            backgroundColor: "#EFF3FE", 
            color: "black", 
            borderRadius: "17px",
            textTransform: "none",
         }}
          variant="contained"
          onClick={exportUsers}
          startIcon={
            <Box
              component="img"
              src="/icons/export-csv.svg"
              alt="export"
              sx={{ width: 40, height: 24 }}
            />
          }
        >
          Export Users
        </Button>
      </Box>

      {subscriptionLookupStatus && (
        <Box sx={{ px: 2, pb: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Fetching subscription data: {subscriptionLookupStatus.completed}/{subscriptionLookupStatus.total}
          </Typography>
        </Box>
      )}

      <TableContainer component={Paper} sx={{ minHeight: 400, maxHeight: 700, overflowX: "auto", overflowY: "auto", width: "100%"}}> 
        <Table
          stickyHeader
          size="small"
          sx={{
            tableLayout: "auto",
            width: "max-content",
            minWidth: "100%",
            "& .MuiTableCell-root": {
              borderRight: "1px solid #e0e0e0",
              whiteSpace: "nowrap",    
              overflow: "hidden",
              textOverflow: "clip",     
            },
          }}
        >
          <TableHead>
            {/* FILTER ROW */}
            <TableRow>
              <FilterCell>
                  <TableFilterInput
                    placeholder="Search First Name"
                    value={filters.firstName}
                    onChange={(e) => handleSearchChange("firstName", e.target.value)}
                  />
                </FilterCell>
              <FilterCell>
                <TableFilterInput
                  placeholder="Search Last Name"
                  value={filters.lastName}
                  onChange={(e) => handleSearchChange("lastName", e.target.value)}
                />
              </FilterCell>
              <FilterCell>
                <TableFilterInput
                  placeholder="Search Email"
                  value={filters.email}
                  onChange={(e) => handleSearchChange("email", e.target.value)}
                />
              </FilterCell>
              <FilterCell>
                <TableFilterInput
                  placeholder="Search Country"
                  value={filters.country}
                  onChange={(e) => handleSearchChange("country", e.target.value)}
                />
              </FilterCell>
              <FilterCell>
                <TableFilterInput
                  placeholder="Search Created At"
                  value={filters.createdAt}
                  onChange={(e) => handleSearchChange("createdAt", e.target.value)}
                />
              </FilterCell>

              <FilterCell>
                <TableFilterInput
                  select
                  placeholder="Subscription Type"
                  value={filters.subscriptionType ?? ""}
                  onChange={(e) => handleSearchChange("subscriptionType", e.target.value)}
                  SelectProps={{ displayEmpty: true }}
                  sx={{
                    "& .MuiSelect-select": {
                        color: filters.subscriptionType ? "#1F2A44" : "#7588B7",
                    },
                }}
                >
                  <MenuItem value="">All users</MenuItem>
                  <MenuItem value="subscribed">Any subscriptions</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                  <MenuItem value="yearly">Yearly</MenuItem>
                  <MenuItem value="none">Non-subscribers</MenuItem> 
                </TableFilterInput>
                  
              </FilterCell>

              <FilterCell>
                <TableFilterInput
                    select
                    value={filters.isLicenseActive ?? ""}
                    onChange={(e) =>
                    handleSearchChange("isLicenseActive", e.target.value)
                    }
                    SelectProps={{ displayEmpty: true }}
                    sx={{
                    "& .MuiSelect-select": {
                        color: filters.isLicenseActive ? "#1F2A44" : "#7588B7",
                    },
                    }}
                >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                </TableFilterInput>
              </FilterCell>

              <FilterCell>
                <TableFilterInput
                    select
                    value={filters.profileCompleted ?? ""}
                    onChange={(e) => handleSearchChange("profileCompleted", e.target.value)}
                    SelectProps={{ displayEmpty: true }}
                    sx={{
                    "& .MuiSelect-select": {
                        color: (filters.profileCompleted ?? "") ? "#1F2A44" : "#7588B7",
                    },
                    }}
                >
                    <MenuItem value="">Profile Completed</MenuItem>
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                </TableFilterInput>
              </FilterCell>

              <FilterCell>
                <TableFilterInput
                    select
                    value={filters.profession ?? ""}
                    onChange={(e) => handleSearchChange("profession", e.target.value)}
                    SelectProps={{ displayEmpty: true }}
                    sx={{
                    "& .MuiSelect-select": {
                        color: (filters.profession ?? "") ? "#1F2A44" : "#7588B7",
                    },
                    }}
                >
                    <MenuItem value="">Profession</MenuItem>

                    {uniqueProfessions.map((p) => (
                    <MenuItem key={p} value={p?.toLowerCase()}>
                        {p}
                    </MenuItem>
                    ))}
                </TableFilterInput>
              </FilterCell>

              <FilterCell>
                <TableFilterInput
                    select
                    value={filters.ageGroup ?? ""}
                    onChange={(e) => handleSearchChange("ageGroup", e.target.value)}
                    SelectProps={{ displayEmpty: true }}
                    sx={{
                    "& .MuiSelect-select": {
                        color: (filters.ageGroup ?? "") ? "#1F2A44" : "#7588B7",
                    },
                    }}
                >
                    <MenuItem value="">Age Group
                    </MenuItem>

                    {uniqueAgeGroups.map((g) => (
                    <MenuItem key={g} value={g?.toLowerCase()}>
                        {g}
                    </MenuItem>
                    ))}
                </TableFilterInput>
              </FilterCell>

              <FilterCell>
                <TableFilterInput
                  placeholder="Search Specialty"
                  value={filters.specialty}
                  onChange={(e) => handleSearchChange("specialty", e.target.value)}
                />
              </FilterCell>

              <FilterCell>
                <TableFilterInput
                  placeholder="Search Institution"
                  value={filters.institution}
                  onChange={(e) => handleSearchChange("institution", e.target.value)}
                />
              </FilterCell>
            </TableRow>

            {/* HEADER ROW */}
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.firstName }}>First Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.lastName }}>Last Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.email }}>Email</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.country }}>Country</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.createdAt }}>Created At</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.subscriptionType }}>Subscription Type</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.isLicenseActive }}>License Active</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.profileCompleted }}>Profile Completed</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.profession }}>Profession</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.ageGroup }}>Age Group</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.specialty }}>Specialty</TableCell>
              <TableCell sx={{ fontWeight: "bold", color:"#003ABA", width: columnWidths.institution }}>Institution</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginated.map((u, idx) => (
              <TableRow key={idx}>
                <TableCell>{u.firstName}</TableCell>
                <TableCell>{u.lastName}</TableCell>
                <TableCell title={u.email || ""}>{u.email}</TableCell>
                <TableCell>{u.country}</TableCell>
                <TableCell>{formatDateTime(u.createdAt)}</TableCell>
                <TableCell>{u.subscriptionType}</TableCell>
                <TableCell>{u.isLicenseActive ? "Yes" : "No"}</TableCell>
                <TableCell>{u.profileCompleted ? "Yes" : "No"}</TableCell>
                <TableCell>{u.profession}</TableCell>
                <TableCell>{u.ageGroup}</TableCell>
                <TableCell>{u.specialty}</TableCell>
                <TableCell>{u.institution}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={filteredUsersLength}
        page={page}
        onPageChange={(_e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={PAGE_SIZE_OPTIONS}
      />
    </Paper>
  );
};

export default UsersTableSection;
